import React from "react";
import styled from "styled-components";
import { GlobalToken, theme } from "antd";
const { useToken } = theme;

export interface ResponseCardProps {
  title?: string | React.ReactNode;
  children?: React.ReactNode;
  contentPadding?: string;
  style?: React.CSSProperties;
  extra?: React.ReactNode;
}

const Card = styled.div<{ $token: GlobalToken }>`
  border-radius: 8px;
  border: 1px solid ${(props) => props.$token.colorBorder};
  background-color: ${(props) => props.$token.colorBgContainer};
  display: block;
  margin: 8px 0;
`;

const CardHeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

const CardHeader = styled.div<{ $token: GlobalToken }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-items: center;
  padding: 0 1rem;
  min-height: 3rem;
  background-color: ${(props) => props.$token.Card?.headerBg};
  border-bottom: 1px solid ${(props) => props.$token.colorBorder};
`;

const CardTitle = styled.div<{ $token: GlobalToken }>`
  font-size: 1rem;
  display: inline-block;
  flex: 1;
  box-sizing: border-box;
  white-space: nowrap;
  font-weight: 600;
  color: ${(props) => props.$token.colorText};
`;

const CardContent = styled.div<{ $padding?: string }>`
  padding: ${(props) => props.$padding || "0"};
`;

export const ResponsiveCard = (props: ResponseCardProps) => {
  const { token } = useToken();

  return (
    <Card style={props.style} $token={token}>
      <CardHeader $token={token}>
        <CardHeaderWrapper>
          <CardTitle $token={token}>{props.title}</CardTitle>
          {props.extra}
        </CardHeaderWrapper>
      </CardHeader>
      <CardContent $padding={props.contentPadding}>
        {props.children}
      </CardContent>
    </Card>
  );
};
